export default __webpack_public_path__ + "static/media/blue01.28ca9fb3.png";